module.exports = __webpack_public_path__ + "img/map-location-small-en.fb201486.jpg";